import { Row, Col, Typography, Image } from "antd";
import Logo from "../../../../assets/images/osd-econnect-2025.png";
import LogoAi from "../../../../assets/images/aidriven-econnect-2025.png";
import LogoDate from "../../../../assets/images/date-econnect-2025.png";
import LogoDateVip from "../../../../assets/images/date-econnect-2025-vip.png";
import LocationDate from "../../../../assets/images/location-econnect-2025.png";
import { useParams } from "react-router";

export interface Props {
  onChangeData: (dataField: any, newdataField: any) => void;
}

export const EconnectStepOne: React.FC<Props> = ({ onChangeData }) => {
  const { agendaid, typeregis, customerid } = useParams<{ agendaid: string; typeregis: string; customerid: string }>();
  return (
    <>
      <div className="w-[353px] h-[653.18px] top-[99px] left-[25px] rounded-[10px] pt-[32px] pr-[26px] pb-[32px] pl-[26px] gap-[32px]">
        <div className="w-[301px] h-[77.87px] gap-[10px] pb-4">
          <Image src={Logo} preview={false} />
        </div>
        <br />
        <br />
        <div className="w-[301px] h-[163.31px]">
          <Image src={LogoAi} preview={false} />
        </div>
        <br />
        <br />
        <br />
        <div className="w-[301px] h-[72px]">
          {typeregis === "vip" ? <Image src={LogoDateVip} preview={false} /> : <Image src={LogoDate} preview={false} />}
        </div>
        <br />
        <br />
        <br />
        <div className="w-[301px] h-[72px]">
          <Image src={LocationDate} preview={false} />
        </div>
        <br />
        {/* <div className="text-center">
          <Row gutter={[8, 8]} className="pt-7.5 pb-7.5">
            <Col span={24} className="colresponse mt-[5%] ">
              <Typography className="typoinColresponse">{`EMPOWERING TECH`}</Typography>
            </Col>
            <Col span={24} className="colresponse">
              <Typography className="typoinCol2response">{`ALLIANCES`}</Typography>
            </Col>
            <Col span={24} className="colresponse">
              <Typography className="typoinColresponse">{`FOR BUSINESS GROWTH`}</Typography>
            </Col>
            <Col span={24} className="colresponse mt-[5%] ">
              <Typography className="typoinColresponse">{`05.07.2023`}</Typography>
            </Col>
            <Col span={24} className="colresponse mb-[5%] ">
              <Typography className="typoinCol3response">{`@ Grand Ballroom, Carlton Sukhumvit`}</Typography>
            </Col>
          </Row>
        </div> */}
      </div>
    </>
  );
};
